import { AccountModel } from "@verivest/shared-components/src/api/models";
import { validateAddressReqAttr } from "./validateAddressReqAttr";
import { validateAllAttributesExistInData } from "./validateAllAttributesExistInData";

export const validateIndividualReqAttr = (
  individual: AccountModel | null | undefined,
) => {
  if (!individual) {
    return false;
  }

  const individualReqAttr: Array<keyof AccountModel> = [
    "firstName",
    "lastName",
    "domicile",
    "citizenship",
    "email",
    "dateOfBirth",
  ];

  if (
    individual.citizenship === "US" ||
    individual.domicile === "U.S. Citizen" ||
    individual.domicile === "U.S. Resident"
  ) {
    individualReqAttr.push("taxIdNumber");
  }

  const isIndividualValid = validateAllAttributesExistInData(
    individualReqAttr,
    individual,
  );
  const isPrimaryAddressValid = validateAddressReqAttr(
    individual.primaryAddress,
  );

  let isMailingAddressValid = true;
  if (individual.mailingAddress) {
    isMailingAddressValid = validateAddressReqAttr(individual.mailingAddress);
  }

  return isIndividualValid && isPrimaryAddressValid && isMailingAddressValid;
};
